import { CampaignProductScope } from '@/constants/CampaignProductScope';

export function resetProductSelectionForScope(scope, setValue) {
    const set = (name, val) => setValue(name, val, { shouldDirty: true });

    if (scope === CampaignProductScope.ALL) {
        set('brandIds', []);
        set('categoryIds', []);
        set('productId', null);
        set('productIds', []);
        return;
    }

    if (scope === CampaignProductScope.GROUP) {
        set('productId', null);
        set('productIds', []);
        return;
    }

    if (scope === CampaignProductScope.SINGLE) {
        set('brandIds', []);
        set('categoryIds', []);
        set('productIds', []);
    }
}

export default resetProductSelectionForScope;
